import React, { useEffect, useState } from 'react';
import { PlayCircle } from 'lucide-react';
import { PlayFab } from '../../app/services/PlayFab';

function Pill({ children }: { children: React.ReactNode }) {
  return <span className="mb-pill">{children}</span>;
}

export default function ProgramPage() {
  const [program, setProgram] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await PlayFab.post('Client/GetUserData', { Keys: ['Programs_current'] });
        if (res.status !== 200) throw new Error('failed to fetch pointer');
        const ptrStr = res.body?.data?.Data?.Programs_current?.Value || '';
        if (!ptrStr) { setProgram(null); setLoading(false); return; }
        const ptr = JSON.parse(ptrStr);
        const key = `Programs_${ptr.id}`;
        const res2 = await PlayFab.post('Client/GetUserData', { Keys: [key] });
        if (res2.status !== 200) throw new Error('failed to fetch program');
        const progStr = res2.body?.data?.Data?.[key]?.Value || '';
        if (!progStr) { setProgram(null); }
        else { setProgram(JSON.parse(progStr)); }
      } catch (e:any) {
        setError(e?.message || 'error');
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  if (loading) return <div className="mb-stack"><div className="mb-card">Loading program…</div></div>;
  if (error) return <div className="mb-stack"><div className="mb-card">Error: {error}</div></div>;
  if (!program) return <div className="mb-stack"><div className="mb-card">No saved program yet.</div></div>;

  const p = {
    split: program?.name || 'Training Program',
    days_per_week: program?.weeks?.[0]?.days?.length || 3,
    duration_weeks: Array.isArray(program?.weeks) ? program.weeks.length : 0,
    experience_level: 'All levels',
    notes: program?.notes || 'Program generated by GymBuddy.',
    training_days: (Array.isArray(program?.weeks) ? program.weeks : []).flatMap((w:any) => {
      return (w?.days || []).map((d:any) => ({
        name: d?.name || 'Day',
        focus: d?.focus || '',
        movements: (d?.exercises || []).map((x:any) => ({
          name: x?.name || 'Exercise',
          sets: x?.sets || 3,
          reps: x?.reps || '8-10',
          pattern_classification: { is_compound: !!(x?.isCompound || x?.compound) },
          cue: x?.notes || ''
        }))
      }));
    })
  };

  return (
    <div className="mb-stack">
      <div className="mb-row-between">
        <div>
          <div className="mb-h1">{p.split}</div>
          <div className="mb-muted">{p.days_per_week} days/wk • {p.duration_weeks} wks • {p.experience_level}</div>
        </div>
        <span className="mb-badge">Program</span>
      </div>
      <div className="mb-card">
        <div className="mb-muted">{p.notes}</div>
      </div>
      <div className="mb-scroll">
        {p.training_days.map((d: any) => (
          <div key={d.name} className="mb-card">
            <div className="mb-row-between mb-mb8">
              <div className="mb-strong">{d.name}</div>
              <Pill>{d.focus}</Pill>
            </div>
            <div className="mb-col-gap">
              {d.movements.map((m: any) => (
                <div key={m.name} className="mb-row-between mb-row-item">
                  <div>
                    <div className="mb-item-title">{m.name}</div>
                    <div className="mb-item-sub">{m.sets} × {m.reps} • {m.pattern_classification.is_compound ? 'Compound' : 'Isolation'}</div>
                    <div className="mb-item-cue">{m.cue}</div>
                  </div>
                  <button className="mb-btn-secondary small"><PlayCircle size={16} style={{marginRight: '6px'}} />Start</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


